// src/utils/socket.js

import { io } from 'socket.io-client';

/**
 * Servicio de WebSocket para conectar con el backend.
 * Exportado como un Singleton.
 */
class SocketService {
    constructor() {
        this.socket = null;
        this.connected = false;
    }

    /**
     * Conectar al servidor Socket.IO
     */
    connect() {
        if (this.socket && this.connected) {
            console.log('Socket ya está conectado');
            return this.socket;
        }

        // Obtener la URL de entorno. 
        // CLAVE: Usamos 'http://localhost:4000' como fallback para desarrollo local
        const socketUrl = 'https://joseluishidalgo.com';


        try {

            this.socket = io(socketUrl, {
                path: '/valery/socket.io', // <--- CLAVE: Aquí le dices dónde buscar realmente
                transports: ['websocket', 'polling'],
                reconnection: true,
                reconnectionDelay: 2000,
                reconnectionAttempts: 3,
                timeout: 10000,
                autoConnect: true
            });

            // Eventos de conexión
            this.socket.on('connect', () => {
                console.log('✅ Conectado a Socket.IO:', this.socket.id);
                this.connected = true;

                // Unirse a la sala de administración
                this.socket.emit('join-admin-panel');
            });

            this.socket.on('connect_error', (error) => {
                console.warn('⚠️ WebSocket no disponible (Connect Error):', error.message);
                this.connected = false;
            });

            this.socket.on('error', (error) => {
                console.warn('⚠️ Error en Socket:', error.message);
                this.connected = false;
            });

            this.socket.on('disconnect', (reason) => {
                console.log('⚠️ Desconectado de Socket.IO:', reason);
                this.connected = false;
            });

            return this.socket;
        } catch (error) {
            console.warn('⚠️ No se pudo inicializar WebSocket:', error.message);
            this.connected = false;
            return null;
        }
    }

    /**
     * Desconectar del servidor
     */
    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
            this.connected = false;
            console.log('Socket desconectado');
        }
    }

    /**
     * Escuchar evento 'nueva-venta'
     * @param {Function} callback - Función que se ejecuta cuando se recibe una nueva venta
     */
    onNuevaVenta(callback) {
        if (!this.socket) {
            console.error('Socket no está conectado. Llama a connect() primero.');
            return;
        }
        this.socket.on('nueva-venta', callback);
    }

    /**
     * Dejar de escuchar evento 'nueva-venta'
     */
    offNuevaVenta() {
        if (this.socket) {
            this.socket.off('nueva-venta');
        }
    }

    /**
     * Verificar si está conectado
     * @returns {boolean}
     */
    isConnected() {
        // Usa el estado interno 'connected'
        return this.connected;
    }
}

// Exportar una instancia única (singleton)
export default new SocketService();